import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { Sun, Moon } from 'lucide-react';
import content from '../../i18n/content';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const { lang } = useLanguage();
  const t = content[lang].nav;
  const label = theme === 'dark' ? t.themeToggleLabelDark : t.themeToggleLabelLight;

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      <span className="theme-toggle-icon">
        {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
      </span>
    </button>
  );
};

export default ThemeToggle;
